import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Box, CircularProgress, Stack } from '@mui/material';
import { toast } from 'react-toastify';
import StoreService from '../components/StoreService';
import InventoryManagerFeature from '../features/inventory/components/InventoryManager';

const InventoryManager = () => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    const fetchStores = async () => {
      setLoading(true);
      try {
        const response = await StoreService.fetchStores();
        const rawStores = response?.response || response || [];
        const normalized = rawStores
          .map((store) => ({
            id: String(store._id ?? store.id ?? ''),
            name: store.name || 'Magasin',
          }))
          .filter((store) => store.id);
        if (mounted) {
          setStores(normalized);
          setError('');
        }
      } catch (err) {
        const message =
          err?.response?.data?.error ||
          err?.message ||
          "Erreur lors du chargement des magasins.";
        if (mounted) {
          setError(message);
        }
        toast.error(message);
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchStores();
    return () => {
      mounted = false;
    };
  }, []);

  const content = useMemo(() => {
    if (loading) {
      return (
        <Box display="flex" justifyContent="center" py={6}>
          <CircularProgress size={32} />
        </Box>
      );
    }

    if (error) {
      return <Alert severity="error">{error}</Alert>;
    }

    if (!stores.length) {
      return <Alert severity="info">Aucun magasin disponible.</Alert>;
    }

    return <InventoryManagerFeature stores={stores} />;
  }, [error, loading, stores]);

  return (
    <Stack spacing={3} sx={{ p: { xs: 2, md: 4 } }}>
      {content}
    </Stack>
  );
};

export default InventoryManager;
